import React from "react";
import UserSummary from "../../components/UserSummary/UserSummary.jsx";
import SummaryTabs from "../../components/Tabs/SummaryTabs.jsx";

export default function Home() {
  return <UserSummary />;
}
